import React, { useState, useCallback, Fragment } from "react";
import { Link, useStaticQuery, graphql } from "gatsby";

import { Menu, MenuItem, IconButton } from "@mui/material";

import { getEntityUrl, getTranslatedEntityLink } from "../../util"
import {Language} from "@mui/icons-material";

const LANGUAGE_ICON_GLOBE = true;

const LanguageSelector = ({ locales, pageContext, entity, ...props }) => {
    const { allStrapiAppSettings: settings } = useStaticQuery(staticQuery);

    const { defaultLocale, locale: selectedLocale } = pageContext || {};


    const [anchorEl, setAnchorEl] = useState(null);
    const open = Boolean(anchorEl);

    const handleMenu = (event) => {
        event.stopPropagation();
        setAnchorEl(event.currentTarget);
    };

    const handleClose = useCallback((e) => {
        e.stopPropagation();
        setAnchorEl(null);
    }, [setAnchorEl]);

    return settings.nodes[0]?.Topbar?.languageSelection === 'topbar' && (locales?.length > 1 || settings.nodes[0]?.Topbar?.pseudoLanguages > 0) && (
        <Fragment>
            <IconButton
                edge="end"
                color="inherit"
                aria-label="language"
                onClick={handleMenu}>
                {LANGUAGE_ICON_GLOBE ? <Language /> : selectedLocale?.split('-').shift()}
            </IconButton>
            <Menu anchorEl={anchorEl} open={open} onClose={handleClose} getContentAnchorEl={null} keepMounted style={{ zIndex: 65535 }}
                anchorOrigin={{ vertical: "bottom", horizontal: "left", }} >

                {locales.map(l => {
                    const link = getTranslatedEntityLink({ locale: l, defaultLocale, entity });

                    return <MenuItem key={l.code} onClick={handleClose} component={Link} to={link}>{l.name}</MenuItem>
                })}

                {settings.nodes[0]?.Topbar?.pseudoLanguages?.map(item => {
                    const link = getEntityUrl({ defaultLocale, entity: item });

                    return <MenuItem key={item.identifier} onClick={handleClose} component={Link} to={link}>{item.title}</MenuItem>
                })}
            </Menu>
        </Fragment>
    )
};

export default LanguageSelector;

const staticQuery = graphql`
    query {
        allStrapiAppSettings {
            nodes {
                Topbar {
                    pseudoLanguages  {
                        identifier
                        title
                        locale
                    }
                    languageSelection
                }
            }
        }
    }
`;

